module.exports = __webpack_public_path__ + "components/closing-infographics/static/infographic--FR-6af694e51a327c4778710ae586cb52fa.jpg";